import type { ReferencedProduct } from 'server/model/marketplace/product/referencedProductModel';
import type { ProductGridProduct } from 'types/Product';
import type { PathTranslations } from 'service/localization/getPathTranslations';

export const mapProductToCarousel = (
  product: ReferencedProduct,
  linkText: string = 'Learn more',
  pathTranslations: PathTranslations,
): ProductGridProduct => {
  const mappedProduct: ProductGridProduct = {
    id: product.id,
    category: '',
    subCategory: '',
    slug: product?.slug || product.id,
    title: product.productTitle,
    productDietList: product.productDietList,
    fillingQuantity: product.fillingQuantity || '',
    metaKeywords: product.metaKeywords || 'na',
    link: {
      url: `${pathTranslations.product}${product.slug || ''}`,
      displayName: linkText,
    },
    subBrand: null,
    createdAt: product.createdAt ?? '',
    updatedAt: product.updatedAt ?? '',
  };

  if (product?.productImage?.url) {
    mappedProduct.images = {
      desktop: product?.productImage?.desktop,
      mobile: product.productImage?.mobile,
      mimeType: String(product.productImage?.mimeType),
    };
  }

  return mappedProduct;
};
